import React, { Fragment, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import CornerSVG from "@components/icons/corner-svg";

export type TooltipPosition = {
  top: number;
  left: number;
};

type PropsType = {
  showTooltip: boolean;
  tooltipPosition: TooltipPosition;
  textId: string;
};

function Tooltip({ showTooltip, tooltipPosition, textId }: PropsType) {
  const [animationTooltip, setAnimationTooltip] = useState<string>(
    "animate-slow-opacity-show",
  );

  useEffect(() => {
    if (showTooltip) {
      setTimeout(() => {
        setAnimationTooltip("animate-bounce-slow");
      }, 249);
    } else {
      setAnimationTooltip("animate-slow-opacity-show");
    }
  }, [showTooltip, animationTooltip]);

  if (!showTooltip) return null;

  return (
    <div
      style={{
        left: `${tooltipPosition.left - 1}px`,
        top: `${tooltipPosition.top}px`,
      }}
      className={classNames(
        "dark:bg-green-dark-default absolute z-10 whitespace-nowrap rounded rounded-bl-none bg-green py-1 px-2 text-base-xs font-bold text-white dark:text-black md:-top-[25px] md:text-base",
        [animationTooltip],
      )}
    >
      <FormattedMessage id={textId} />
      <CornerSVG
        classNameProps={classNames(
          "left-0 absolute -bottom-[7px] h-auto w-[10px] md:-bottom-[10px] md:w-[16px]",
        )}
      />
    </div>
  );
}

export default Tooltip;
